import Hero from "../components/Hero";
import AboutMe from "../components/AboutMe";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import React from "react";
import trackPathForAnalytics from "../analytics/TrackJobForAnalytics";

function Home() {
  trackPathForAnalytics({ action: "website open", title: "view portfolio" });
  return (
    <>
      <Hero />
      <AboutMe />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

export default Home;
